import React, { useState } from "react";
import "../css/WebDesign.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedBack from "../images/AnimatedBack.gif";
import AnimatedWebdesign from "../images/AnimatedWebdesign.gif";
import Webdesign1 from "../images/Webdesign1.png";
import Webdesign2 from "../images/Webdesign2.png";
import Webdesign3 from "../images/Webdesign3.png";
import Webdesign4 from "../images/Webdesign4.png";
import Webdesign5 from "../images/Webdesign5.png";
import Webdesign6 from "../images/Webdesign6.png";
import PHP1 from "../images/PHP1.png";
import PHP2 from "../images/PHP2.png";
import PHP3 from "../images/PHP3.png";
import PHP4 from "../images/PHP4.webp";
import PHP5 from "../images/PHP5.jpeg";
import OS1 from "../images/OS1.jpg";
import OS2 from "../images/OS2.png";
import OS3 from "../images/OS3.jpeg";
import OS4 from "../images/OS4.jpeg";
import OS5 from "../images/OS5.jpeg";
import OS6 from "../images/OS6.webp";
import OS7 from "../images/OS7.jpg";
import HTML1 from "../images/HTML1.webp";
import HTML2 from "../images/HTML2.jpeg";
import HTML3 from "../images/HTML3.jpg";
import HTML4 from "../images/HTML4.jpeg";
import JS1 from "../images/JS1.png";
import JS2 from "../images/JS2.jpeg";
import JS3 from "../images/JS3.jpg";
import JS4 from "../images/JS4.png";
import JS5 from "../images/JS5.jpeg";
import NET1 from "../images/NET1.webp";
import NET2 from "../images/NET2.png";
import Customer from "../components/Customer";

function WebDesign() {
  const [dropdowns, setDropdowns] = useState({
    PHP: false,
    OS: false,
    HTML: false,
    JS: false,
    ASP: false,
  });

  const toggleDropdown = (service) => {
    setDropdowns((prev) => {
      const resetDropdowns = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});

      return {
        ...resetDropdowns,
        [service]: !prev[service],
      };
    });
  };

  return (
    <>
      <Header />
      <div className="WebDesign">
        <div className="Webdesign-above">
          <img className="Webdesign-img" src={AnimatedBack} alt="" />
          <div className="Webdesign-above-info">
            <p className="Webdesign-p" style={{ marginTop: "-70px", marginBottom: "-40px" }} >Web Design</p>
            <p
              className="Webdesign-p"
              style={{ marginTop: "-10px", marginBottom: "-10px" }}
            >
              we’re experts
            </p>
            <p className="Webdesign-p1">
              Outstanding Web Designs for Your Business
            </p>
          </div>
        </div>
        <div className="Webdesign-main">
          <p
            className="Webdesign-main-p"
            style={{ fontSize: "30px", fontWeight: "bolder" }}
          >
            Leading Web Design Experts Providing Tailored and Optimized Web
            Solutions
          </p>
          <p p className="Webdesign-main-p">
            We provide end-to-end web design services for your business,
            focusing on crafting high-performing, intuitive, and secure websites
            that set industry standards and deliver exceptional user
            experiences.
          </p>
          <div className="Webdesign-main1">
            <div className="Webdesign-info">
              <p style={{ marginTop: "30px" }}>
                <strong>A website</strong> is more than just a visual presence;
                it’s a powerful tool that bridges the gap between your business
                and its audience, <strong>offering</strong> a real-time showcase
                of your value and offerings.{" "}
                <strong>As a leading web design company,</strong> we specialize
                in designing visually captivating, user-centric websites while
                utilizing advanced analytics to ensure they drive measurable
                success and effectively achieve your business objectives.
              </p>

              <p style={{ marginTop: "30px" }}>
                <strong>As a professional Website Development Company,</strong>{" "}
                we specialize in creating bespoke, seamless websites that are
                meticulously tailored to achieve your unique online goals.{" "}
                <strong>Each design</strong> is a reflection of your core
                values, combining aesthetic appeal with advanced analytics to
                drive measurable success and elevate your digital presence.
              </p>

              <p style={{ marginTop: "30px" }}>
                <strong>Our commitment</strong> to innovation and custom web
                design ensures that your ideas are transformed into impactful
                digital experiences.{" "}
                <strong>By choosing to work with us,</strong> you’re investing
                in accelerated business growth, elevated user interactions, and
                a measurable boost in revenue. We don’t just build websites;{" "}
                <strong>we create</strong> platforms that amplify your brand and
                drive lasting success in the competitive digital landscape.
              </p>
            </div>
            <img
              className="Webdesign-main1-img"
              src={AnimatedWebdesign}
              alt=""
            />
          </div>
          <div className="Webdesign-main2" style={{ marginTop: "100px" }}>
            <p
              className="Webdesign-main-p"
              style={{ fontSize: "30px", fontWeight: "bolder" }}
            >
              Wide range of Website design Services
            </p>
            <p className="Webdesign-main-p">
              We are one of the most well-known web design companies. Our web
              design services cover the following
            </p>
            <div className="Webd-main2-boxes">
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webdesign1} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Custom Web App Development
                </p>
                <p style={{ marginTop: "20px" }}>
                  We provide custom web application development services,
                  utilizing proven methods to help you achieve your business
                  goals.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webdesign2} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  UI/UX (User Interface/User Experience) Design
                </p>
                <p style={{ marginTop: "20px" }}>
                  We design intuitive user interfaces that not only elevate the
                  user experience but also boost engagement, ensuring seamless
                  navigation and satisfaction for your audience.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webdesign3} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Open Source Project Services
                </p>
                <p style={{ marginTop: "20px" }}>
                  By leveraging the power of open-source technologies, we create
                  robust, scalable, and innovative platforms that not only
                  streamline your operations but also help you stand out in a
                  highly competitive market.
                </p>
              </div>
            </div>
            <div className="Webd-main2-boxes">
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webdesign4} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Quality Assurance
                </p>
                <p style={{ marginTop: "20px" }}>
                  We employ the QMS (Quality Management System) methodology to
                  guarantee that your web application is secure, durable, and
                  high-performing, ensuring it meets the highest standards of
                  quality and reliability.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webdesign5} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Services for Frontend Development
                </p>
                <p style={{ marginTop: "20px" }}>
                  Our user interface team designs solutions that deliver
                  seamless functionality across all devices, ensuring fast
                  performance and an optimal user experience, regardless of the
                  connection speed.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webdesign6} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Backend Development Services
                </p>
                <p style={{ marginTop: "20px" }}>
                  We have extensive experience in building scalable back-end
                  systems that offer flexible integration, handle complex data
                  structures, and provide top-tier security to ensure robust and
                  reliable performance.
                </p>
              </div>
            </div>
          </div>
          <div className="Webd-main3">
            <p className="Webd-main3-p">
              Services we offers for Web Development
            </p>
            <p className="Webd-main3-p1">
              Excellence and innovation Using the Most Recent Technology
            </p>
            <div className="Webd-main3-options">
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("PHP")}
              >
                <i className="fa-brands fa-php fa-xl"></i>
                <p>PHP</p>
                {dropdowns.PHP && (
                  <div className="dropdown-info">
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      PHP is a widely-used, open-source, server-side programming
                      language favored by developers. Its seamless integration
                      with HTML makes it an ideal choice for building complex
                      and dependable websites.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP1}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          CodeIgniter
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP2}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Laravel
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP3}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Cake PHP
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP4}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>YII</p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP5}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>Zend</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("OS")}
              >
                <i className="fa-brands fa-osi fa-xl"></i>
                <p>Open Source</p>
                {dropdowns.OS && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-250px" }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      We utilize open-source technologies, tools, and frameworks
                      to help your business website stand out, as they form the
                      backbone of your online presence. The open design allows
                      your team to contribute creatively, enabling a website
                      that is highly customizable, secure, and versatile.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS1} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Drupal
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS2} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Joomla
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS3} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Magento
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS4} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Open Cart
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS5} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Presta Shop
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS6} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Shopify
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS7} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          WordPress
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("HTML")}
              >
                <i className="fa-brands fa-html5 fa-xl"></i>
                <p>HTML5 & CSS3</p>
                {dropdowns.HTML && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-500px" }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      Develop websites that deliver an intuitive user experience
                      across multiple devices, browsers, and platforms, while
                      enhancing browsing performance and optimizing local data
                      storage.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML1}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          BootStrap
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML2}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>CSS3</p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML3}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Grid System
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML4}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          HTML5
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("JS")}
              >
                <i className="fa-brands fa-square-js fa-xl"></i>
                <p>JavaScript</p>
                {dropdowns.JS && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-750px" }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      We excel in JavaScript, creating highly responsive
                      interfaces that enhance customer experiences and provide
                      dynamic functionality. Leveraging one of the most
                      versatile programming languages with extensive
                      repositories, we implement features like search boxes with
                      predictive suggestions, seamless content loading, and
                      engaging on-page animations.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS1} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Angular JS
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS2} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          JQuery
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS3} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Node Js
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS4} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          React Js
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS5} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Vue Js
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("ASP")}
              >
                <i className="fa-brands fa-battle-net fa-xl"></i>
                <p>ASP .Net</p>
                {dropdowns.ASP && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-1000px" }}
                  >
                    <p
                    style={{
                      fontSize: "20px",
                      color: "white",
                      fontWeight: "medium",
                    }}>
                      Using a powerful server-side application framework, we
                      develop dynamic and scalable web pages. Our developers
                      maximize the potential of just-in-time compilation, native
                      optimization, and caching services. With ASP.NET, we
                      deliver enterprise-grade websites and web applications
                      tailored to meet complex business needs.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={NET1}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          .Net MVC
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={NET2}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          .Net Core
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        
          <Customer />
        
      </div>
      <Footer />
    </>
  );
}

export default WebDesign;
